export const MANAGE_USERS_PERMISSION = 'manage_users';
export const FIELD_SCRAMBLING_ERROR = 'FIELD_SCRAMBLING_ERROR';
export const RESOLVE_ERROR = 'RESOLVE_ERROR';
